import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenInterestsStyles = styled(OnboardingPage)`
  .local-options {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 440px;
    justify-content: center;
    gap: 12px;
    margin: 24px auto 0;
    padding: 0 10px;

    @media screen and (min-width: 576px) {
      margin: 50px auto 0;
      gap: 16px;
    }

    @media screen and (min-width: 768px) {
      max-width: 650px;
      margin: 70px auto 0;
    }

    &-item {
      background: var(--background-color-light);
      padding: 6px 14px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;

      @media screen and (min-width: 576px) {
        padding: 8px 16px;
      }

      @media screen and (min-width: 768px) {
        padding: 10px 18px;
      }

      .icon svg g path {
        background: var(--background-color-primary);
        color: black;
        fill: black;
      }

      &.checked {
        background: var(--background-color-primary);
        color: white;

        .icon svg g path {
          color: white;
          fill: white;
        }
      }

      input[type='checkbox'] {
        display: none;
      }
    }
  }
`;
